//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Selectize from 'vue2-selectize';
export default {
  props: {
    value: {
      type: String,
      default: '',
      require: false
    },
    baseValue: {
      type: String,
      default: '',
      require: false
    },
    baseTitle: {
      type: String,
      default: 'Location',
      require: false
    },
    options: {
      type: Array,
      default: [],
      require: false
    }
  },
  components: {
    Selectize
  },
  watch: {
    categoryValue: function (newVal, oldVal) {
      if (newVal === 'all') {
        this.$emit('input', '');
        return;
      }
      this.$emit('input', newVal.toString());
    }
  },
  data: () => ({
    categoryValue: ''
  }),
  mounted() {
    this.categoryValue = this.value;
  },
  methods: {
    onChangeSelect() {
      this.$emit('input', this.categoryValue.toString());
    }
  }
};